import {
	CONTENT_TYPES,
	LIBRARY_TYPES,
	MODES,
	SORT_OPTIONS,
	SortOrderTranslations
} from './library-collection-viewer.constants';
import { SelectedService, selectedServiceToken } from 'go-modules/services/selected/selected.service';
import { UserService, userServiceToken } from 'go-modules/models/user/user.service';
import { FullstoryService, fullstoryToken } from 'go-modules/services/fullstory/fullstory.service';
import { FULLSTORY_EVENTS } from 'go-modules/services/fullstory/fullstory.events';
import {
	ActivityEditorPanel,
	activityEditorPanelToken
} from 'go-modules/activity-editor-panel/activity-editor-panel.service';
import { catchError, debounceTime, distinctUntilChanged, finalize } from 'rxjs/operators';
import { MediaSource } from 'go-modules/models/media';
import { VideoQualityUtil } from '@go-modules/utilities/video-quality/video-quality.util';
import { GoSidepanelService } from '@go-modules/services/go-sidepanel/go-sidepanel.service';
import {
	ManageCollectionsPanelComponent
} from '@go-modules/components/library/manage-collections-panel/manage-collections-panel.component';
import {
	Component,
	ElementRef,
	EventEmitter,
	HostListener,
	Inject,
	Input,
	OnDestroy,
	OnInit,
	Output,
	ViewChild
} from '@angular/core';
import { LibraryService } from '@go-modules/services/library/library.service';
import { goModal, goModalToken } from 'go-modules/modals/go-modal.factory';
import { umcChooserToken, UniversalMediaChooserFactory } from 'go-modules/universal-media-chooser/umc.factory';
import { rubricEditorModalToken } from 'go-modules/modals/rubric-editor/modal.factory';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { activityToken } from 'go-modules/models/activity/activity.factory';
import { activityTemplateModelToken } from 'go-modules/models/activity-template/activity-template.factory';
import { EMPTY, forkJoin, Subject, Subscription } from 'rxjs';
import { NgxGroupService } from '@go-modules/services/group/group.service';
import { ZoomService } from '@go-modules/services/zoom/zoom.service';
import { MessageDialogComponent } from '../../dialogs/message-dialog/message-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { NgxActivityService } from '@go-modules/services/activity/activity.service';
import { ConfirmDialogComponent, ConfirmDialogData } from '../../dialogs/confirm-dialog/confirm-dialog.component';
import { SearchPipe } from '@go-modules/pipes/search/search.pipe';
import { Sizes } from 'go-modules/responsive-view/responsive-view.service';
import { NgxMediaService } from '@go-modules/services/media/media.service';
import { ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { GoModalService } from '@go-modules/services/go-modal/go-modal.service';
import {
	DESTINATION_MODES
} from '@go-modules/components/library/collection-destination/collection-destination.constants';
import {
	CollectionDestinationComponent,
	CollectionDestinationData
} from '@go-modules/components/library/collection-destination/collection-destination.component';
import {
	ManageLibraryCollectionFolderComponent
} from '../manage-library-collection-folder/manage-library-collection-folder.component';
import { MarkerSetDialogComponent } from '../../dialogs/marker-set-dialog/marker-set-dialog.component';
import { NgxFeatureFlagService } from '@go-modules/services/feature-flag/feature-flag.service';
import {
	LibraryFilterAndSortTourService
} from '@go-modules/tours/library-filter-and-sort-tour/library-filter-and-sort-tour.service';
import { ProductTier } from '@go-modules/interfaces/licenses/product-tier';
import { GoToastStatusType } from '@go-modules/enums/go-toast-status-type';
import { NgxGoToastService } from '@go-modules/services/go-toast/go-toast.service';
import type { ContentTypeType } from '@go-modules/interfaces/library/library-types';
import type {
	LibraryCollection,
	LibraryCollectionItem,
	LibraryCollectionItemsAndFolders
} from '@go-modules/interfaces/library/library-collection';
import type { CollectionDestinationResponse } from '@go-modules/interfaces/library/collection-destination-response';
import { LibraryTreeDataSource } from '@go-modules/components/library/library-tree-viewer/library-tree-datasource';
import { LibraryTreeViewerComponent } from '../library-tree-viewer/library-tree-viewer.component';
import { CollectionDestinationModule } from '../collection-destination/collection-destination.module';
import { ManageLibraryCollectionFolderModule } from '../manage-library-collection-folder/manage-library-collection-folder.module';
import { MarkerSetDialogModule } from '@go-modules/components/dialogs/marker-set-dialog/marker-set-dialog.module';
import { GoSelectModule } from '@go-modules/directives/go-select/go-select.module';
import { NgxZeroStateModule } from '@go-modules/components/zero-state/zero-state.module';
import { A11yModule } from '@angular/cdk/a11y';
import { SortPipeModule } from '@go-modules/pipes/sort/sort.pipe.module';
import { SearchPipeModule } from '@go-modules/pipes/search/search.pipe.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { FormsModule } from '@angular/forms';
import { CollectionFolderViewerModule } from '../collection-folder-viewer/collection-folder-viewer.module';
import { CollectionItemViewerModule } from '../collection-item-viewer/collection-item-viewer.module';
import { ManageCollectionsPanelModule } from '../manage-collections-panel/manage-collections-panel.module';
import { GoPulseTourService } from '@go-modules/services/go-pulse-tour/go-pulse-tour.service';
import { MULTI_LEVEL_LIBRARY_FOLDER_TOUR_CONFIG } from '@go-modules/services/go-pulse-tour/constants/multi-level-library-folder-tour';
import { LibraryActivityPanelStateService } from '@go-modules/services/library/library-activity-panel-state.service';

@Component({
	selector: 'ngx-library-collection-viewer',
	templateUrl: './library-collection-viewer.component.html',
	styleUrls: ['./library-collection-viewer.component.scss'],
	providers: [LibraryActivityPanelStateService, LibraryTreeDataSource],
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		FormsModule,
		ReactiveFormsModule,
		CollectionFolderViewerModule,
		CollectionItemViewerModule,
		ManageCollectionsPanelModule,
		SortPipeModule,
		SearchPipeModule,
		MatTooltipModule,
		NgxZeroStateModule,
		A11yModule,
		CollectionDestinationModule,
		ManageLibraryCollectionFolderModule,
		MarkerSetDialogModule,
		GoSelectModule,
		LibraryTreeViewerComponent
	]
})
export class LibraryCollectionViewerComponent implements OnInit, OnDestroy {
	@ViewChild('collectionItemsListRef') public collectionItemsListRef!: ElementRef;

	public mainPanelLoading: boolean = true;
	public sidePanelLoading: boolean = true;
	public sidePanelVisible: boolean = true;
	public sortBy: string = SORT_OPTIONS.LASTMODIFIED;
	public sortOptions = Object.values(SORT_OPTIONS);
	public sortOrderTranslations = SortOrderTranslations;
	public collections: LibraryCollection[];
	public archiveCollection: LibraryCollection;
	public visibleCollections: LibraryCollection[];
	public selectedCollection: LibraryCollection;
	public contentTypes: ContentTypeType[];
	public selectedContentType: ContentTypeType;
	public collectionItems: LibraryCollectionItemsAndFolders;
	public expanded: string[] = [];
	public expandedFolders: number[] = [];
	public currentlySelected: any;
	public itemHeight: number = 45;
	public expandedHeight: number = 370;
	public searchStrForm = new UntypedFormControl('', Validators.minLength(2));
	public searchStr: string = '';
	public searchError: string = '';
	private searchStrSub: Subscription;
	private previousValue: string;
	@Input() public filterType: CONTENT_TYPES[];
	@Input() public mode: string;
	public modes = MODES;
	public libraryTypes = LIBRARY_TYPES;
	@Input() public previewable: boolean = false;
	@Input() public collectionManagement: boolean = true;
	@Input() public create: boolean = false;
	@Input() public openToOrg: number;
	public itemsWithoutFolder: LibraryCollectionItem[];
	@Output() public selectItem: EventEmitter<any> = new EventEmitter();
	// eslint-disable-next-line @angular-eslint/no-output-native
	@Output() public cancel: EventEmitter<any> = new EventEmitter();
	public multiSelect: boolean = false;
	public selectAllChecked: boolean = false;
	public orgSettings;
	public selectedGroup;
	private umc: any;
	public readonly activityPanelIsOpen = this.libraryActivityPanelStateService.panelOpen;
	public toggledItemEl: HTMLButtonElement;
	private resizeObserver: ResizeObserver;
	public shouldTrapFocusToSidepanel: boolean = false;
	public sidePanelDestroyed$$ = new Subject();
	public CONTENT_TYPES = CONTENT_TYPES;
	public contentTypesWithoutAll: ContentTypeType[];
	public useTreeView = this.featureFlag.isAvailable('LIB_FOLDERS');

	constructor (
		private libraryService: LibraryService,
		private ngxGoSidepanelService: GoSidepanelService,
		private modal: GoModalService,
		private dialog: MatDialog,
		private groupService: NgxGroupService,
		private elementRef: ElementRef,
		private zoomService: ZoomService,
		private translate: TranslateService,
		private activityService: NgxActivityService,
		private searchPipe: SearchPipe,
		private mediaService: NgxMediaService,
		private featureFlag: NgxFeatureFlagService,
		private libraryFilterAndSortTourService: LibraryFilterAndSortTourService,
		private ngxGoToastService: NgxGoToastService,
		private treeDataSource: LibraryTreeDataSource,
		private pulseTourService: GoPulseTourService,
		private libraryActivityPanelStateService: LibraryActivityPanelStateService,
		@Inject(goModalToken) private goModalService: ReturnType<typeof goModal>,
		@Inject(umcChooserToken) private UniversalMediaChooser: ReturnType<typeof UniversalMediaChooserFactory>,
		@Inject(selectedServiceToken) private selectedService: SelectedService,
		@Inject(rubricEditorModalToken) private rubricEditorModal,
		@Inject(userServiceToken) private userService: UserService,
		@Inject(fullstoryToken) private fullstoryService: FullstoryService,
		@Inject(activityToken) private ActivityModel,
		@Inject(activityTemplateModelToken) private ActivityTemplateModel,
		@Inject(activityEditorPanelToken) private activityEditorPanel: ActivityEditorPanel
	) {}

	public ngOnInit () {
		this.fullstoryService.createEvent(FULLSTORY_EVENTS.NEW_LIBRARY_LOADED, {});
		if (this.mode === this.modes.SELECT) {
			this.fullstoryService.createEvent(FULLSTORY_EVENTS.NEW_LIBRARY_SELECT_MODE, {});
		}
		this.selectedGroup = this.selectedService.getGroup() || this.selectedService.getAccount();

		forkJoin([
			this.groupService.getOrgSettings(this.selectedService.getOrg().group_id),
			this.libraryService.getCollections(),
			this.libraryService.getCollectionItemTypes()
		]).subscribe((results) => {
			const [orgSettings, collections, types] = results;
			this.orgSettings = orgSettings;
			this.collections = collections.sort((a, b) =>
				this.findPermission(a).sort_order - this.findPermission(b).sort_order);

			// Hide My History collection on SELECT mode
			if (this.mode === MODES.SELECT) {
				this.collections = this.collections.filter((collection) =>
					collection.type !== this.libraryTypes.ARCHIVE);
			}

			this.archiveCollection = collections.filter((collection) =>
				collection.type === this.libraryTypes.ARCHIVE)[0];

			this.visibleCollections = this.collections.filter((collection) =>
				this.findPermission(collection).is_hidden === false);
			// set selectedCollection to lowest sort order, which is already sorted above
			this.selectedCollection = this.visibleCollections[0];
			const localCollectionId = localStorage.getItem('last-selected-library-collection');
			if (this.openToOrg) {
				const orgCollection = this.collections
					.find((collection) => collection.org_id === this.openToOrg);
				if (orgCollection !== undefined) {
					this.selectedCollection = orgCollection;
				}
			} else if (localCollectionId) {
				const localCollection = this.visibleCollections
					.find((collection) => collection.id === parseInt(localCollectionId, 10));
				if (localCollection !== undefined) {
					this.selectedCollection = localCollection;
				}
			}

			this.contentTypes = [{ name: 'All', slug: 'all', sort_order: -1 }, ...types];
			if (this.filterType) {
				this.contentTypes = this.contentTypes.filter((type) =>
					this.filterType.includes(type.slug));
			}
			this.selectedContentType = this.contentTypes.reduce((prev, curr) =>
				prev.sort_order < curr.sort_order ? prev : curr);
			const lastContentTypeSlug = localStorage.getItem('last-selected-content-type');
			if (lastContentTypeSlug) {
				const selectedContentType = this.contentTypes.find((type) => type.slug === lastContentTypeSlug);
				if (selectedContentType !== undefined) {
					this.selectedContentType = selectedContentType;
				}
			}
			this.contentTypesWithoutAll = types.filter((type) => type.slug !== 'all');

			this.sidePanelLoading = false;

			this.libraryService.getCollectionItems(
				this.selectedCollection.id,
				this.selectedContentType.slug
			).subscribe((items) => {
				this.collectionItems = this.applyPreviewableFilter(items);

				if (this.useTreeView) {
					this.treeDataSource.setSortBy(this.getSortKey());
					this.treeDataSource.setCollectionItems(
						this.collectionItems,
						this.selectedCollection.id,
						this.selectedContentType.slug
					);
				} else {
					this.itemsWithoutFolder = this.findItemsInFolder(null);
				}

				this.mainPanelLoading = false;
			});

			if (this.create) {
				this.addActivity(this.selectedCollection, null, null);
			}
		});

		this.searchStrSub = this.searchStrForm.valueChanges
			.pipe(
				debounceTime(this.useTreeView ? 500 : 0),
				distinctUntilChanged()
			)
			.subscribe((newValue) => {
				this.handleSearchChange(newValue);
			});

		this.observeSize();

		this.umc = this.UniversalMediaChooser.get('umcModal');

		if (!this.mode) {
			this.libraryFilterAndSortTourService.getTour().start();
		}

		if (this.featureFlag.isAvailable('LIB_FOLDERS')) {
			this.pulseTourService.startTour(MULTI_LEVEL_LIBRARY_FOLDER_TOUR_CONFIG).pipe(
				catchError(() => EMPTY)
			).subscribe();
		}
	}

	public select (event) {
		if (this.selectedCollection?.type === this.libraryTypes.MANAGED &&
			!this.userService.currentUser.is_root_content &&
			event.item.collection_item_type !== CONTENT_TYPES.ACTIVITIES) {
			this.libraryService.copyManagedCollectionItem(event.item.id).subscribe(({item}) => {
				this.selectItem.emit({item});
			});
		} else {
			this.selectItem.emit(event.item);
		}
	}

	public updateItems () {
		this.itemsWithoutFolder = this.findItemsInFolder(null);
	}

	public setActivityPanelIsOpen (val) {
		this.libraryActivityPanelStateService.setIsOpen(val);
	}

	public setCurrentlySelected (val) {
		this.currentlySelected = val;
	}

	public setSelectAllChecked (val) {
		this.selectAllChecked = val;
	}

	public handleSearchChange (searchStr: string): void {
		const trimmed = searchStr?.trim() || '';

		// use backend search
		if (this.useTreeView) {
			// Handle empty search
			if (trimmed === '') {
				this.searchError = '';
				this.searchStr = '';
				this.selectAllChecked = false;
				this.treeDataSource.clearAllChecked();
				this.treeDataSource.setSearch(this.searchStr);

				// Reload without search
				this.mainPanelLoading = true;
				this.loadNewItems();
				return;
			}

			if (trimmed.length < 3) {
				this.searchError = 'library-collections_search-min-chars';
				return;
			}

			// Clear any error and load new search
			this.searchError = '';
			this.mainPanelLoading = true;
			this.searchStr = trimmed;
			this.selectAllChecked = false;
			this.treeDataSource.clearAllChecked();
			this.treeDataSource.setSearch(trimmed);
			this.loadNewItems();
		} else {
			this.searchStr = trimmed;

			if (trimmed !== '' || this.previousValue && this.previousValue.length > 0) {
				this.selectAllChecked = false;
				this.collectionItems.items.map((item) => item.checked = false);
			}
			this.previousValue = trimmed;
		}
	}

	public onSearchBlur (): void {
		if (!this.useTreeView) return;

		const trimmed = this.searchStrForm.value?.trim() || '';
		if (trimmed === '') {
			this.searchError = '';
		}
	}

	public showActionContainer () {
		const collectionType = this.selectedCollection?.type;

		if (collectionType === this.libraryTypes.MANAGED) {
			return this.userService.currentUser.is_root_content;
		}

		const excludedTypes = [
			this.libraryTypes.DIRECT_SHARE,
			this.libraryTypes.ARCHIVE,
			this.libraryTypes.LEGACY
		];

		return !excludedTypes.includes(collectionType);
	}

	public hideOnArchiveAndManaged () {
		return this.selectedCollection?.type === this.libraryTypes.ARCHIVE ||
			(this.selectedCollection?.type === this.libraryTypes.MANAGED &&
				!this.userService.currentUser.is_root_content);
	}

	public ngOnDestroy () {
		this.searchStrSub?.unsubscribe();
		this.resizeObserver?.disconnect();
		this.sidePanelDestroyed$$.next(true);
		this.sidePanelDestroyed$$.complete();
		this.treeDataSource.disconnect();
	}

	private observeSize () {
		const checkSidePanel = (entries) => {
			const measurements = entries[0].contentRect;
			this.sidePanelVisible = true;
			this.expandedHeight = 370;
			for (const css of this.elementRef.nativeElement.classList.values()) {
				if (css.startsWith('resize-sensor-')) {
					this.elementRef.nativeElement.classList.remove(css);
				}
			}

			[Sizes.XXSMALL, 380, Sizes.XSMALL, Sizes.TABLET].forEach((width) => {
				if (measurements.width <= width) {
					this.elementRef.nativeElement.classList.add(`resize-sensor-${width}`);
				}
			});

			if (measurements.width <= Sizes.TABLET) {
				this.sidePanelVisible = false;
			}

			if (measurements.width >= Sizes.XSMALL) {
				this.expandedHeight = 226;
			}
		};

		this.resizeObserver = new ResizeObserver(checkSidePanel);
		this.resizeObserver.observe(this.elementRef.nativeElement);
	}

	public showOverlay () {
		return this.sidePanelVisible;
	}

	@HostListener('window:keydown.escape', ['$event'])
	public handleEscapePress (_event: KeyboardEvent) {
		if (this.sidePanelVisible) {
			this.toggleSidePanel();
		}
	}

	public toggleSidePanel () {
		this.sidePanelVisible = !this.sidePanelVisible;

		if (this.sidePanelVisible) {
			setTimeout(() => {
				this.shouldTrapFocusToSidepanel = true;
				const sidePanel = this.elementRef.nativeElement.querySelector('.sidepanel');
				const focusableElements = sidePanel.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');

				// Find the first focusable element
				const firstFocusable = Array.from(focusableElements)[0] as HTMLElement;

				if (firstFocusable) {
					firstFocusable.focus();
				}
			});
		} else {
			this.shouldTrapFocusToSidepanel = false;
			this.toggleButtonFocus();
			this.sidePanelDestroyed$$.next(true);
			this.sidePanelDestroyed$$.complete();
			// Reinitialize the Subject after completing it
			this.sidePanelDestroyed$$ = new Subject();
		}
	}

	public toggleButtonFocus () {
		setTimeout(() => {
			const toggleButton = this.elementRef.nativeElement.querySelector('.toggle-side-panel-btn');
			if (toggleButton) {
				toggleButton.focus();
			}
		});
	}

	public selectCollection (collection) {
		if (this.selectedCollection.type !== this.libraryTypes.LEGACY && collection.type === this.libraryTypes.LEGACY) {
			this.fullstoryService.createEvent(FULLSTORY_EVENTS.NEW_LIBRARY_VIEWED_LEGACY, {});
		}
		localStorage.setItem('last-selected-library-collection', collection.id);
		this.selectedCollection = collection;
		this.mainPanelLoading = true;
		this.loadNewItems();
		if (this.multiSelect) {
			this.toggleMultiSelect();
		}
	}

	public selectContentType (type) {
		localStorage.setItem('last-selected-content-type', type.slug);
		this.selectedContentType = type;
		this.mainPanelLoading = true;

		if (this.useTreeView && this.searchStr && this.searchStr.length >= 3) {
			this.handleSearchChange(this.searchStr);
		} else {
			this.loadNewItems();
		}

		if (this.multiSelect) {
			this.toggleMultiSelect();
		}
	}

	public loadNewItems (expandItem?: {
		collection?: LibraryCollection;
		folder?: { id?: number } | null;
		item?: any
	}): void {
		if (this.useTreeView) {
			const collectionId = (expandItem?.collection?.id ?? this.selectedCollection.id);
			const folderId = expandItem?.folder?.id ?? null;

			// Folder refresh path
			if (folderId) {
				this.libraryService
					.getCollectionItems(collectionId, this.selectedContentType.slug, { folder_id: folderId })
					.subscribe((resp) => {
						const filtered = this.applyPreviewableFilter(resp);
						this.treeDataSource.applyFolder(folderId, filtered);
						this.mainPanelLoading = false;
					});
				return;
			}

			// Root refresh path
			const isSearchActive = this.searchStr && this.searchStr.length >= 3;
			const params = isSearchActive ? { search: this.searchStr } : undefined;

			const switchingCollections = this.treeDataSource.getCollectionId() !== collectionId;
			const shouldPreserve = !isSearchActive && !switchingCollections;

			this.libraryService.getCollectionItems(collectionId, this.selectedContentType.slug, params)
				.subscribe((items) => {
					const filtered = this.applyPreviewableFilter(items);

					this.treeDataSource.applyRoot(
						filtered,
						collectionId,
						this.selectedContentType.slug,
						shouldPreserve
					);
					this.mainPanelLoading = false;
				});
			return;
		}

		if (expandItem && this.mode === MODES.SELECT) {
			this.selectedCollection = expandItem.collection;
		}
		this.libraryService.getCollectionItems(this.selectedCollection.id,
			this.selectedContentType.slug)
			.subscribe((items) => {
				this.collectionItems = this.applyPreviewableFilter(items);

				this.mainPanelLoading = false;
				this.expanded = [];
				this.itemsWithoutFolder = this.findItemsInFolder(null);

				if (expandItem?.folder?.id > 0) {
					setTimeout(() => {
						this.expandedFolders.push(expandItem.folder.id);
					});
				}

				if (expandItem?.item && (!expandItem?.folder || expandItem?.folder?.id === 0)) {
					setTimeout(() => {
						this.scrollToItem();
					});
				}

				if (expandItem?.item && this.mode === MODES.SELECT) {
					let id;
					if (expandItem.item.media_id) {
						id = expandItem.item.media_id;
					} else if (expandItem.item.activity_id) {
						id = expandItem.item.activity_id;
					} else {
						id = expandItem.item.id;
					}

					const collectionItem = this.findItemById(id)[0];
					this.libraryService.getCollectionItemDetails(collectionItem.id).subscribe((res) => {
						collectionItem.item = res.item;
						this.expanded.push(collectionItem.hash);
					});
				}
			});
	}

	public openManageCollectionsPanel () {
		this.fullstoryService.createEvent(FULLSTORY_EVENTS.NEW_LIBRARY_MANAGE_COLLECTIONS, {});
		const libraryModal = document.querySelector('library-dialog .modal-dialog') as HTMLElement;
		this.ngxGoSidepanelService.open(ManageCollectionsPanelComponent, {
			inputs: {
				collections: [...this.collections]
			},
			noFooter: true,
			closeOnBackdropClick: true,
			closeOnEscape: true,
			panelClass: ['manage-collections-panel']
		}, libraryModal).afterClosed().subscribe((collections) => {
			if (collections) {
				this.collections = collections;
				this.selectedCollection = collections.find((collection) => {
					return collection.id === this.selectedCollection.id;
				});
				this.visibleCollections = collections.filter((collection) =>
					this.findPermission(collection)?.is_hidden === false);
			}
			const toggleButton = this.elementRef.nativeElement.querySelector('.manage-collections-btn');
			toggleButton.focus();
		});
	}

	public getSortKey (isFolder: boolean = false) {
		let itemField: string = 'name';

		if (this.sortBy === SORT_OPTIONS.ALPHANUMERICREVERSE) {
			itemField = '-name';
		} else if (this.sortBy === SORT_OPTIONS.LASTMODIFIED) {
			itemField = isFolder ? '-updated_at' : '-modified_at';
		} else if (this.sortBy === SORT_OPTIONS.NEWEST) {
			itemField = '-created_at';
		} else if (this.sortBy === SORT_OPTIONS.OLDEST) {
			itemField = 'created_at';
		}

		return itemField;
	}

	public updateTreeSort (): void {
		if (this.useTreeView) {
			this.treeDataSource.setSortBy(this.getSortKey());
		}
	}

	public getResultsCount (): number {
		if (this.useTreeView) {
			// Tree view uses search api - visible items are already the filtered results
			return this.treeDataSource.getVisibleItems().length;
		}
		return this.searchPipe.transform(this.collectionItems.items, this.searchStr, ['name', 'description', 'creator_name']).length;
	}

	public clearSearch () {
		if (this.searchStrForm.value === '') return;

		this.searchStrForm.setValue('');
		this.searchError = '';
		setTimeout(() => {
			this.elementRef.nativeElement.querySelector('.search-input').focus();
		});
	}

	public addLibraryItem (selectedType) {
		this.clearSearch();

		const destinationModalData: CollectionDestinationData = {
			collections: this.collections,
			selectedCollection: this.selectedCollection,
			contentType: selectedType.slug,
			mode: DESTINATION_MODES.ADD,
			defaultFolderId: null,
			allowSkip: this.mode === MODES.SELECT && selectedType.slug !== CONTENT_TYPES.ACTIVITIES
		};
		if (this.currentlySelected?.id) {
			destinationModalData.defaultFolderId = this.currentlySelected.id;
		} else if (this.currentlySelected && this.currentlySelected.hash && this.currentlySelected?.folderId) {
			destinationModalData.defaultFolderId = this.currentlySelected.folderId;
		}

		this.modal.open(CollectionDestinationComponent, false, {
			data: destinationModalData
		}).afterClosed().subscribe((res: CollectionDestinationResponse) => {
			const toggleButton = this.elementRef.nativeElement.querySelector('.add-btn');
			toggleButton.focus();

			if (res.dismissed) {
				if (res.hasFolderAdded) {
					if (res.collection.id === this.selectedCollection.id) {
						this.loadNewItems();
					}
				}
				return;
			}
			const {collection, folder, autoSelect, skipCollection, hasFolderAdded} = res;

			if (this.useTreeView && hasFolderAdded && folder) {
				const folderForDatasource = {
					...folder,
					item_counts: {
						activity: 0,
						document: 0,
						markers: 0,
						media: 0,
						rubric: 0
					}
				};
				this.treeDataSource.addFolder(folderForDatasource, folder.parent_id);
			}

			if (collection && collection.id !== this.selectedCollection.id) {
				this.selectedCollection = collection;
			}

			const modalData = {
				options: {}
			};
			let addToFolder = null;
			if (folder?.id > 0){
				addToFolder = folder.id;
			}

			if (selectedType.slug === CONTENT_TYPES.MEDIA ||
				selectedType.slug === CONTENT_TYPES.DOCUMENTS) {
				if (selectedType.slug === CONTENT_TYPES.MEDIA){
					const videoQuality = this.selectedService.getLicense()?.salesforce_license.video_quality ??
						VideoQualityUtil.MINIMUM_RESOLUTION;

					modalData.options = {
						defaultSection: this.umc.MEDIA_TYPE.UPLOAD,
						headerOptions: [
							this.umc.MEDIA_TYPE.RECORD_VIDEO,
							this.umc.MEDIA_TYPE.UPLOAD,
							this.umc.MEDIA_TYPE.YOUTUBE,
							this.umc.MEDIA_TYPE.RECORD_AUDIO,
							this.umc.MEDIA_TYPE.ZOOM
						],
						chooseAutomatically: true,
						groupId: this.selectedGroup.group_id,
						goRecorder: {
							videoQuality
						},
						uploadSizeLimit: this.selectedGroup.upload_limit ?
							this.selectedGroup.upload_limit * 1024 * 1024 : null,
						addToCollection: collection?.id,
						addToFolder
					};
				} else {
					modalData.options = {
						blacklist: 'fine-uploader/src/partials/dangerous-file-blacklist.json',
						defaultSection: this.umc.MEDIA_TYPE.UPLOAD,
						headerOptions: [
							this.umc.MEDIA_TYPE.UPLOAD
						],
						chooseAutomatically: true,
						groupId: this.selectedGroup.group_id,
						uploadSizeLimit: this.selectedGroup.upload_limit ?
							this.selectedGroup.upload_limit * 1024 * 1024 : null,
						addToCollection: collection?.id,
						addToFolder,
						uploadMinSizeLimit: 1,
						mediaType: selectedType.slug
					};
				}
				this.goModalService.open({
					modal: 'umc',
					modalData
				}).result.then((res) => {
					if (res.source === MediaSource.ZOOM_IMPORT) {
						this.zoomService.queueImport(res.media_id, {
							group_id: this.selectedGroup.group_id,
							download_url: res.zoom_download_url,
							resource_id: this.selectedCollection.id,
							resource_type: 'library_collection'
						}).subscribe({
							next: () => {},
							error: () => {
								this.dialog.open(MessageDialogComponent, {
									data: {
										title: this.translate.instant('zoom-queue-recordings-error_title'),
										message: this.translate.instant('zoom-queue-recordings-error_message')
									}
								});
							}
						});
					}

					if (autoSelect) {
						this.selectItem.emit({item: res});
						if (!skipCollection) {
							this.ngxGoToastService.createToast({
								type: GoToastStatusType.SUCCESS,
								message: 'library-collections-auto-select-media'
							});
						}
					} else {
						this.loadNewItems({collection, folder, item: res});
					}
				}).catch(() => {});
			} else if (selectedType.slug === CONTENT_TYPES.RUBRICS) {
				modalData.options = {
					schemaId: null,
					mode: 'edit',
					postData: {
						group_id: this.selectedGroup.group_id,
						add_to_collection: collection?.id,
						add_to_folder: addToFolder
					}
				};

				this.rubricEditorModal.open({
					modalData
				}).result.then((res) => {
					if (autoSelect) {
						this.selectItem.emit({item: res});
						if (!skipCollection) {
							this.ngxGoToastService.createToast({
								type: GoToastStatusType.SUCCESS,
								message: 'library-collections-auto-select-rubric'
							});
						}
					} else {
						this.loadNewItems({collection, folder, item: res});
					}
				}).catch(() => {});
			} else if (selectedType.slug === CONTENT_TYPES.MARKERS) {
				this.modal.open(MarkerSetDialogComponent, false, {
					data: {
						addToCollection: collection?.id,
						addToFolder
					}
				}).afterClosed().subscribe((res) => {
					if (!res.dismissed) {
						if (autoSelect) {
							this.selectItem.emit({item: res});
							if (!skipCollection) {
								this.ngxGoToastService.createToast({
									type: GoToastStatusType.SUCCESS,
									message: 'library-collections-auto-select-markers'
								});
							}
						} else {
							this.loadNewItems({collection, folder, item: res});
						}
					}
				});
			} else if (selectedType.slug === CONTENT_TYPES.ACTIVITIES) {
				this.addActivity(collection, folder, addToFolder);
			}
		});
	}

	public openAddFolderModal () {
		this.clearSearch();

		this.fullstoryService.createEvent(FULLSTORY_EVENTS.NEW_LIBRARY_CREATE_FOLDER_CLICK, {});

		if (!this.useTreeView && this.collectionItems.folders.length >= 100) {
			return this.dialog.open(MessageDialogComponent, {
				data: {
					title: this.translate.instant('library-collections_max-folders-title'),
					message: this.translate.instant('library-collections_max-folders-message')
				}
			});
		}

		let folder = null;
		if (this.useTreeView) {
			let folderId = null;
			if (this.currentlySelected?.id) {
				folderId = this.currentlySelected.id;
			} else if (this.currentlySelected && this.currentlySelected.hash && this.currentlySelected.folderId) {
				folderId = this.currentlySelected.folderId;
			}

			if (folderId) {
				const folderNode = this.treeDataSource.getFolderNodeById(folderId);
				if (folderNode) {
					folder = folderNode.data;
				}
			}
		}

		return this.modal.open(ManageLibraryCollectionFolderComponent, false, {
			data: {
				createMode: true,
				existingFolders: this.useTreeView ? [] : this.collectionItems.folders,
				selectedCollection: this.selectedCollection,
				folder
			}
		}).afterClosed().subscribe((res) => {
			const toggleButton = this.elementRef.nativeElement.querySelector('.add-folder-btn');
			toggleButton.focus();
			if (res.dismissed) {
				return;
			}
			if (res.request_failed) {
				return this.dialog.open(MessageDialogComponent, {
					data: {
						title: this.translate.instant('library-collections_add-folder-fail-title'),
						message: this.translate.instant('library-collections_add-folder-fail-message')
					}
				});
			}
			const newFolder = res;
			this.fullstoryService.createEvent(FULLSTORY_EVENTS.NEW_LIBRARY_FOLDER_CREATED, {});

			if (this.useTreeView) {
				this.treeDataSource.addFolder(newFolder, newFolder.parent_id);
			} else {
				this.collectionItems.folders = [...this.collectionItems.folders, newFolder];
			}
		});
	}

	public toggleMultiSelect (): void {
		if (!this.multiSelect) {
			this.selectAllChecked = false;

			if (this.useTreeView) {
				this.treeDataSource.clearAllChecked();
			} else {
				this.collectionItems.items.map((item) => {
					item.checked = false;
				});
			}
		}
	}

	public shouldShowZeroState (): boolean {
		if (this.useTreeView) {
			return !this.treeDataSource.hasContent();
		}
		return this.collectionItems.items.length === 0 && this.collectionItems.folders.length === 0;
	}

	public getItemCount (): number {
		if (this.useTreeView) {
			return this.treeDataSource.getVisibleItems().length;
		}
		return this.collectionItems.items.length;
	}

	public getFolderCount (): number {
		if (this.useTreeView) {
			return this.treeDataSource.getVisibleFolders().length;
		}
		return this.collectionItems.folders.length;
	}

	public setActiveToggle ($event) {
		this.toggledItemEl = $event.currentTarget;
	}

	public selectAll (): void {
		if (this.useTreeView) {
			this.treeDataSource.selectAllVisible(this.selectAllChecked);
		} else {
			//  expand all folders and select all items
			this.collectionItems.items.map((item) => {
				item.checked = this.selectAllChecked;
			});

			if (this.selectAllChecked) {
				this.collectionItems.folders.map((folder) => {
					this.expandedFolders.push(folder.id);
				});
			} else {
				this.expandedFolders = [];
			}
		}
	}

	public copyItems () {
		const checkedItems = this.useTreeView
			? this.treeDataSource.getCheckedItems()
			: this.collectionItems.items.filter((item) => item.checked);

		if (!checkedItems.length) {
			return this.dialog.open(MessageDialogComponent, {
				data: {
					title: this.translate.instant('library-collections_multi-select-none-selected'),
					message: this.translate.instant('library-collections_multi-select-none-selected-message')
				}
			});
		}
		const dialogRef: MatDialogRef<ConfirmDialogComponent, any> = this.dialog.open(ConfirmDialogComponent, {
			data: {
				title: this.translate.instant('library-collections_multi-select-batch-copy-title'),
				message: this.translate.instant('library-collections_multi-select-batch-copy-message'),
				confirmText: this.translate.instant('common_continue'),
				cancelText: this.translate.instant('common_cancel')
			} as ConfirmDialogData
		});

		dialogRef.afterClosed().subscribe((confirm) => {
			if (confirm) {
				const destinationData: CollectionDestinationData = {
					collections: this.collections,
					selectedCollection: this.selectedCollection,
					contentType: this.selectedContentType.slug,
					mode: DESTINATION_MODES.COPY
				};
				this.modal.open(CollectionDestinationComponent, false, {
					data: destinationData
				}).afterClosed().subscribe((res) => {
					if (res.dismissed) {
						if (res.hasFolderAdded && res.collection.id === this.selectedCollection.id) {
							this.loadNewItems();
						}
						return;
					}
					const {collection, folder} = res;
					this.mainPanelLoading = true;
					let items = [];
					checkedItems.map((item, i) => {
						items = [...items, {
							collections: [{collection_id: collection.id}]
						}];

						if (folder?.id > 0) {
							items[i].collections[0].folder_id = folder.id;
						}

						// Handle items from archive that may not
						// have an actual libraryItem
						if (item.id) {
							items[i].itemId = item.id;
						} else {
							items[i].item = {
								item_id: item.item_id,
								item_type: item.collection_item_type
							};
						}
					});

					this.libraryService.copyCollectionItem({
						items
					}).subscribe(() => {
						if (this.selectedCollection.id === collection.id) {
							if (this.useTreeView) {
								this.loadNewItems({ collection, folder });
							} else {
								this.loadNewItems();
							}
						}
						this.selectAllChecked = false;
						this.mainPanelLoading = false;

						if (this.useTreeView) {
							this.treeDataSource.clearAllChecked();
						}
					});
				});
			}
		});
	}

	public moveItems () {
		const checkedItems = this.useTreeView
			? this.treeDataSource.getCheckedItems()
			: this.collectionItems.items.filter((item) => item.checked);

		if (!checkedItems.length) {
			return this.dialog.open(MessageDialogComponent, {
				data: {
					title: this.translate.instant('library-collections_multi-select-none-selected'),
					message: this.translate.instant('library-collections_multi-select-none-selected-message')
				}
			});
		}
		const dialogRef: MatDialogRef<ConfirmDialogComponent, any> = this.dialog.open(ConfirmDialogComponent, {
			data: {
				title: this.translate.instant('library-collections_multi-select-batch-move-title'),
				message: this.translate.instant('library-collections_multi-select-batch-move-message'),
				confirmText: this.translate.instant('common_continue'),
				cancelText: this.translate.instant('common_cancel')
			} as ConfirmDialogData
		});

		dialogRef.afterClosed().subscribe((confirm) => {
			if (confirm) {
				const destinationData: CollectionDestinationData = {
					collections: this.collections,
					selectedCollection: this.selectedCollection,
					contentType: this.selectedContentType.slug,
					mode: DESTINATION_MODES.MOVE
				};
				this.modal.open(CollectionDestinationComponent, false, {
					data: destinationData
				}).afterClosed().subscribe((res) => {
					if (res.dismissed) {
						if (res.hasFolderAdded && res.collection.id === this.selectedCollection.id) {
							this.loadNewItems();
						}
						return;
					}
					const {collection, folder} = res;
					this.mainPanelLoading = true;

					const items = checkedItems.map((item) => ({
						library_collection_id: this.selectedCollection.id,
						library_collection_folder_id: item.library_collection_folder_id,
						library_collection_item_id: item.id
					}));

					const data = {
						new_library_collection_id: collection.id,
						new_library_collection_folder_id: folder?.id ?? null,
						items
					};
					this.libraryService.moveCollectionItem(data)
						.pipe(finalize(() => this.mainPanelLoading = false))
						.subscribe({
							next: (res) => {
								if (this.useTreeView && this.selectedCollection.id === collection.id) {
									const moves = checkedItems.map((item) => ({
										itemId: item.id,
										fromFolderId: item.library_collection_folder_id,
										toFolderId: data.new_library_collection_folder_id
									}));
									this.treeDataSource.moveItems(moves);
								} else {
									// Different collection or legacy view - reload
									this.loadNewItems();
								}

								this.selectAllChecked = false;

								if (this.useTreeView) {
									this.treeDataSource.clearAllChecked();
								}

								if (res.itemsNotMoved.length) {
									this.dialog.open(MessageDialogComponent, {
										data: {
											title: this.translate.instant('library-collections_item_move_error-title'),
											message: this.translate.instant('library-collections_item_move_error-batch-message')
										}
									});
								}
							},
							error: () => {
								return this.dialog.open(MessageDialogComponent, {
									data: {
										title: this.translate.instant('library-collections_item_move_error-title'),
										message: this.translate.instant('library-collections_item_move_error-batch-message')
									}
								});
							}
						});
				});
			}
		});
	}

	public removeItems () {
		const checkedItems = this.useTreeView
			? this.treeDataSource.getCheckedItems()
			: this.collectionItems.items.filter((item) => item.checked);

		if (!checkedItems.length) {
			return this.dialog.open(MessageDialogComponent, {
				data: {
					title: this.translate.instant('library-collections_multi-select-none-selected'),
					message: this.translate.instant('library-collections_multi-select-none-selected-message')
				}
			});
		}
		const dialogRef: MatDialogRef<ConfirmDialogComponent, any> = this.dialog.open(ConfirmDialogComponent, {
			data: {
				title: this.translate.instant('library-collections_multi-select-batch-remove-title'),
				message: this.translate.instant('library-collections_multi-select-batch-remove-message'),
				confirmText: this.translate.instant('common_remove'),
				cancelText: this.translate.instant('common_cancel')
			} as ConfirmDialogData
		});

		dialogRef.afterClosed().subscribe((confirm) => {
			if (confirm) {
				this.mainPanelLoading = true;
				this.libraryService.removeCollectionItem(this.selectedCollection.id, checkedItems)
					.pipe(finalize(() => this.mainPanelLoading = false))
					.subscribe({
						next: (res) => {
							if (this.useTreeView) {
								const itemHashes = checkedItems.map((item) => item.hash);
								this.treeDataSource.removeItemsByHash(itemHashes);
							} else {
								// Legacy view - reload
								this.loadNewItems();
							}

							this.selectAllChecked = false;

							if (this.useTreeView) {
								this.treeDataSource.clearAllChecked();
							}

							if (res.itemsNotDeleted.length) {
								this.dialog.open(MessageDialogComponent, {
									data: {
										title: this.translate.instant('library-collections_item_remove_error-title'),
										message: this.translate.instant('library-collections_item_remove_error-batch-message')
									}
								});
							}
						},
						error: () => {
							return this.dialog.open(MessageDialogComponent, {
								data: {
									title: this.translate.instant('library-collections_item_remove_error-title'),
									message: this.translate.instant('library-collections_item_remove_error-batch-message')
								}
							});
						}
					});
			}
		});
	}

	private isPreviewable = (item) => {
		return this.mediaService.isPreviewable({
			media_status: item.media_status,
			media_type: item.media_type,
			filename: item.filename
		});
	};

	private findPermission = (collection) => {
		return collection.library_collection_permissions.find((permission) =>
			permission.user_id === this.userService.currentUser.user_id);
	};

	private findItemsInFolder = (folderId): LibraryCollectionItem[] => {
		return this.collectionItems.items.filter((item) => {
			return item.library_collection_folder_id === folderId;
		});
	};

	private findItemById = (id) => {
		return this.collectionItems.items.filter((item) => {
			return item.item_id === id;
		});
	};

	private addActivity (collection, folder, addToFolder) {
		this.fullstoryService.createEvent(FULLSTORY_EVENTS.NEW_LIBRARY_ADD_ASSIGNMENT, {});
		const headerOptions: any = {
			editMode: false,
			hideName: false
		};

		this.activityService.getDefault()
			.subscribe((defaultActivity) => {
				const activity = this.ActivityModel.useAsTemplate(this.ActivityModel.model(defaultActivity.activity));
				activity.populateEmptyActivityOnGroup(this.selectedGroup);
				activity.add_to_collection = collection.id;
				activity.add_to_folder = addToFolder;
				if (!activity.template.id) {
					if (activity.activity_template_id) {
						const template = this.ActivityTemplateModel.model({
							id: activity.activity_template_id
						});
						activity.setActivityTemplate(template);
					} else {
						this.ActivityTemplateModel.query().$promise.then((templates) => {
							const template = templates.find((t) =>
								t.slug === this.ActivityTemplateModel.TYPE.STANDARD);
							activity.setActivityTemplate(template);
						});
					}
				}

				const license = this.selectedService.getLicense();
				if (this.featureFlag.isAvailable('AI_DEFAULT')
					&& license?.salesforce_license.tier_name === ProductTier.Plus
				) {
					activity.llm_definitions = defaultActivity.aiUseType?.defaultLlmDefinitions;
				}

				this.libraryActivityPanelStateService.setIsOpen(true);
				const isOrgCollectionAndCanModifyItems =
					this.libraryService.isOrgCollectionAndCanModifyItems(collection);

				return this.activityEditorPanel.open({
					user: this.userService.currentUser,
					group: this.selectedGroup,
					activity,
					headerOptions,
					libraryMode: true,
					isOrgCollectionAndCanModifyItems,
					orgSettings: this.orgSettings,
					firstFocusSelector: '#activity-editor-name-input'
				}).result.then((newActivity) => {
					this.libraryActivityPanelStateService.setIsOpen(false);
					this.loadNewItems({collection, folder, item: newActivity});
				}).catch(() => {})
					.finally(() => {
						this.libraryActivityPanelStateService.setIsOpen(false);
					});
			});
	}

	private scrollToItem () {
		const container = this.collectionItemsListRef.nativeElement;
		const target = container.querySelector('.collection-item');

		if (target) {
			target.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
	}

	private applyPreviewableFilter (items: LibraryCollectionItemsAndFolders): LibraryCollectionItemsAndFolders {
		if (this.previewable && this.selectedContentType.slug === CONTENT_TYPES.DOCUMENTS) {
			return {
				...items,
				items: items.items.filter(this.isPreviewable)
			};
		}
		return items;
	}
}
